export default {
  'pages.reviews.title': 'Review Management',
  'pages.reviews.platformReviews': 'Platform Reviews',
  'pages.reviews.userReviews': 'User Reviews',
  'pages.reviews.platformToUser': 'Platform → User Product',
  'pages.reviews.userToProduct': 'User → Product',
  'pages.reviews.platformReviewsDescription': 'Reviews written by platform about user products',
  'pages.reviews.userReviewsDescription': 'Reviews written by users about products',
  
  // Common
  'pages.reviews.user': 'User',
  'pages.reviews.sender': 'Sender',
  'pages.reviews.seller': 'Seller',
  'pages.reviews.rating': 'Rating',
  'pages.reviews.rating.positive': 'Positive',
  'pages.reviews.rating.neutral': 'Neutral',
  'pages.reviews.rating.negative': 'Negative',
  'pages.reviews.content': 'Content',
  'pages.reviews.images': 'Images',
  'pages.reviews.imagesCount': '',
  'pages.reviews.processingMemo': 'Processing Memo',
  'pages.reviews.createdAt': 'Created',
  'pages.reviews.updatedAt': 'Updated',
  'pages.reviews.status': 'Status',
  'pages.reviews.actions': 'Actions',
  
  // Platform Reviews
  'pages.reviews.platform.title': 'Title',
  'pages.reviews.platform.status.active': 'Active',
  'pages.reviews.platform.status.hidden': 'Hidden',
  'pages.reviews.platform.write': 'Write Review',
  'pages.reviews.platform.writeReview': 'Write Product Review',
  'pages.reviews.platform.send': 'Send',
  'pages.reviews.platform.reviewSent': 'Review sent successfully',
  'pages.reviews.platform.reviewError': 'Failed to send review',
  'pages.reviews.platform.ratingRequired': 'Please select a rating',
  
  // User Reviews
  'pages.reviews.user.productInfo': 'Product Info',
  'pages.reviews.user.productNumber': 'Product Number',
  'pages.reviews.user.productName': 'Product Name',
  'pages.reviews.user.sellerName': 'Seller',
  'pages.reviews.user.reviewText': 'Review Text',
  'pages.reviews.user.reviewImages': 'Review Images',
  'pages.reviews.user.platformComment': 'Platform Comment',
  'pages.reviews.user.status.pending': 'Pending',
  'pages.reviews.user.status.approved': 'Approved',
  'pages.reviews.user.status.rejected': 'Rejected',
  
  // Actions
  'pages.reviews.edit': 'Edit',
  'pages.reviews.delete': 'Delete',
  'pages.reviews.approve': 'Approve',
  'pages.reviews.reject': 'Reject',
  'pages.reviews.comment': 'Comment',
  'pages.reviews.commentAndNotes': 'Comment/Notes',
  'pages.reviews.action.view': 'View',
  'pages.reviews.action.respond': 'Respond',
  
  // Modal
  'pages.reviews.modal.commentTitle': 'Platform Comment',
  'pages.reviews.modal.editTitle': 'Edit Platform Review',
  'pages.reviews.modal.approveTitle': 'Approve Review',
  'pages.reviews.modal.rejectTitle': 'Reject Review',
  'pages.reviews.modal.platformComment': 'Platform Comment',
  'pages.reviews.modal.platformCommentPlaceholder': 'Enter comment for user...',
  'pages.reviews.modal.processingMemo': 'Processing Memo (Internal)',
  'pages.reviews.modal.processingMemoPlaceholder': 'Enter internal processing memo...',
  'pages.reviews.modal.handlingNotes': 'Handling Notes (Internal)',
  'pages.reviews.modal.handlingNotesPlaceholder': 'Enter internal handling notes...',
  'pages.reviews.modal.save': 'Save',
  'pages.reviews.modal.cancel': 'Cancel',
  'pages.reviews.contentRequired': 'Please enter review content',
  'pages.reviews.contentPlaceholder': 'Enter review content...',
  'pages.reviews.handlingNotesRequired': 'Please enter handling notes',
  'pages.reviews.handlingNotesPlaceholder': 'Enter handling notes...',
  'pages.reviews.imageUploadNote': 'Maximum 5 images allowed (3MB each)',
  'pages.reviews.addImage': 'Add Image',
  
  // Messages
  'pages.reviews.deleteConfirm': 'Are you sure to delete?',
  'pages.reviews.rejectConfirm': 'Are you sure to reject?',
  'pages.reviews.deleted': 'Deleted successfully',
  'pages.reviews.approved': 'Approved successfully',
  'pages.reviews.rejected': 'Rejected successfully',
  'pages.reviews.commentSaved': 'Comment saved successfully',
  'pages.reviews.commentRequired': 'Please enter comment',
  'pages.reviews.fetchError': 'Failed to fetch reviews',
  'pages.reviews.deleteError': 'Failed to delete',
  'pages.reviews.updated': 'Review updated successfully',
  'pages.reviews.updateError': 'Failed to update',
  'pages.reviews.commentError': 'Failed to save comment',
  'pages.reviews.approveError': 'Failed to approve',
  'pages.reviews.rejectError': 'Failed to reject',
  'pages.reviews.permissionDenied': 'Permission Denied',
  'pages.reviews.noPermissionToEdit': 'You do not have permission to edit this review',
  
  // Search
  'pages.reviews.search.userName': 'User Name',
  'pages.reviews.search.productName': 'Product Name',
  'pages.reviews.search.sellerName': 'Seller Name',
  'pages.reviews.search.title': 'Title',
  
  // Suggestion page (Platform Reviews)
  'pages.suggestion.tab.item': 'Item Quality (Item as Described)',
  'pages.suggestion.tab.customerService': 'Customer Service',
  'pages.suggestion.tab.delivery': 'Delivery Service Quality',
  'pages.suggestion.item.title': 'Item Quality Reviews',
  'pages.suggestion.cs.title': 'Customer Service Reviews',
  'pages.suggestion.delivery.title': 'Delivery Service Reviews',
  'pages.suggestion.reviewType': 'Review Type',
  'pages.suggestion.reviewType.item': 'Item Quality',
  'pages.suggestion.reviewType.customerService': 'Customer Service',
  'pages.suggestion.reviewType.delivery': 'Delivery Service',
  'pages.suggestion.detailTitle': 'Platform Review Details',
  'pages.suggestion.responseTitle': 'Platform Review Response',
};